export const itemCountSingularScreenReaderOnlyText = "uJc";
export const itemCountPluralScreenReaderOnlyText = "vJc";
export const paused = "wJc";
export default {itemCountSingularScreenReaderOnlyText,itemCountPluralScreenReaderOnlyText,paused};